import React, { useEffect, useState } from "react";
import { db } from "../../db/firebaseConfig";
import { collection, getDocs } from "firebase/firestore";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default function ExportarStock() {
  const [productos, setProductos] = useState([]);
  const [loading, setLoading] = useState(true);

  // Traer productos de Firestore
  useEffect(() => {
    const fetchProductos = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "producto"));
        const lista = [];
        querySnapshot.forEach((doc) => {
          lista.push({ id: doc.id, ...doc.data() });
        });
        setProductos(lista);
      } catch (error) {
        console.error("Error obteniendo productos:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProductos();
  }, []);

  // Generar y descargar Excel
  const exportarExcel = () => {
    if (productos.length === 0) return;

    // 1️⃣ Crear hoja de datos
    const wsData = productos.map((p) => ({
      Nombre: p.name,
      Precio: p.price,
      Stock: p.stock,
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);

    // 2️⃣ Crear libro y agregar hoja
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Stock");

    // 3️⃣ Convertir a archivo binario y descargar
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], { type: "application/octet-stream" });
    saveAs(blob, "stock_productos.xlsx");
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <h3 className="text-2xl font-bold mb-4">📄 Stock de Productos</h3>

      {loading ? (
        <p>Cargando productos...</p>
      ) : (
        <>
          <table className="table-auto w-full mb-4 border-collapse border border-gray-300">
            <thead>
              <tr className="bg-gray-200">
                <th className="border px-4 py-2">Nombre</th>
                <th className="border px-4 py-2">Precio</th>
                <th className="border px-4 py-2">Stock</th>
              </tr>
            </thead>
            <tbody>
              {productos.map((p) => (
                <tr key={p.id}>
                  <td className="border px-4 py-2">{p.name}</td>
                  <td className="border px-4 py-2">{p.price}</td>
                  <td className="border px-4 py-2">{p.stock}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <button
            onClick={exportarExcel}
            className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
          >
            Descargar Excel
          </button>
        </>
      )}
    </div>
  );
}
